import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class EmailConfigService {

    constructor(private http: HttpClient) { }

    getAllEmailConfigs(body: any): Observable<any> {
        return this.http.post(environment.getAllEmailConfigs, body);
    }

    createEmailConfig(body: any): Observable<any> {
        return this.http.post(environment.createEmailConfig, body);
    }

    updateEmailConfig(body: any): Observable<any> {
        return this.http.put(environment.updateEmailConfig, body);
    }

    deleteEmailConfig(body: any): Observable<any> {
        return this.http.delete(environment.deleteEmailConfig, { body: body });
    }

    
}
